import { useMemo } from 'react';
import type { FormField } from '../../store/slice';
import {
  getEolStageGroupFields,
  validateEolStagesAtLeastOne,
  updateEolStageDomErrors,
  updateEolLaunchRichTextDomErrors,
  eolStageChangeAffectsValidation,
  eolLaunchRichTextChangeAffectsValidation
} from '../utils/eolStagesValidation';

/**
 * Memoized End of Life — Stages (min one complete stage: notification + effective dates).
 */
export function useEolStagesValidation(
  formFields: FormField[],
  activeMomentType: string | null
) {
  return useMemo(() => {
    const eolStageGroups = getEolStageGroupFields(formFields, activeMomentType);

    return {
      eolStageGroups,
      validateMinOneStage: (
        values: Record<string, unknown>,
        isNotificationDatePresent: (v: unknown) => boolean
      ) =>
        validateEolStagesAtLeastOne(
          eolStageGroups,
          values,
          isNotificationDatePresent
        ),
      syncEolStageDomErrors: (
        values: Record<string, unknown>,
        showErrors: boolean,
        isNotificationDatePresent: (v: unknown) => boolean,
        dom: {
          addRequiredErrorMessage: (el: Element | null) => void;
          removeExistingErrorMessage: (el: Element | null) => void;
          setFieldErrorBorder: (el: Element | null) => void;
          removeFieldErrorBorder: (el: Element | null) => void;
        }
      ) => {
        updateEolStageDomErrors(
          eolStageGroups,
          values,
          showErrors,
          isNotificationDatePresent,
          dom
        );
        updateEolLaunchRichTextDomErrors(
          values,
          showErrors,
          activeMomentType,
          dom
        );
      },
      changeAffectsStages: (changedFieldName: string) =>
        eolStageChangeAffectsValidation(eolStageGroups, changedFieldName),
      changeAffectsEolValidation: (changedFieldName: string) =>
        eolStageChangeAffectsValidation(eolStageGroups, changedFieldName) ||
        eolLaunchRichTextChangeAffectsValidation(changedFieldName)
    };
  }, [formFields, activeMomentType]);
}
